<!-- Clean action card with primary/secondary variants -->
<div [class]="getCardClasses()" class="rounded-lg shadow-xl p-8">
  
  <!-- Header -->
  <div class="text-center mb-4">
    <h4 class="font-[Parisienne] text-3xl text-brand-inktint mb-2">{{ data.title }}</h4>
    <p [class]="getTextClasses()">{{ data.description }}</p>
  </div>
  
  <!-- Button -->
  <div class="text-center">
    <a [routerLink]="[data.routerLink]" 
       [class]="getButtonClasses()"
       class="inline-block px-8 py-4 rounded-lg font-[Neuton] font-semibold transition-colors duration-300 w-full">
      {{ data.buttonText }}
    </a>
  </div>
  
</div>